import React from "react";
import VideoSection from "./VideoSection";

// import headerBackgroundImage from "./card-background-2.png";
// export const VideoIframe = ({ src, title }) => {
//   return (
//     <iframe
//       width="290"
//       height="260"
//       src={src}
//       title={title}
//       frameborder="0"
//       allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//       allowfullscreen
//       className="rounded-xl"
//     ></iframe>
//   );
// };
function Music() {
  return (
    // <div className='' style={{ backgroundImage: `url(${headerBackgroundImage})` }}>
    <div className="py-8">
     
         <h2 className="border-b-2 border-[gainsboro] w-[12%] mx-auto items-center flex-col justify-center font-serif text-center text-blue-800 text-[26px] uppercase rounded-2xl">
         Music      
         </h2>
    <VideoSection/>
    </div>
  );
}

export default Music;
